import { AppBox, AppText } from "../../../../../commons/components";
import { IFootballTeamCoach } from "../../../../../commons/models/football/interface/i-football-team-coach";

interface TeamCoachRemoveProps {
  teamCoach: IFootballTeamCoach;
}
export default function TeamCoachRemovalInprogress({ teamCoach }: TeamCoachRemoveProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Removing <strong>“{teamCoach.fullName}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
